module.exports = __webpack_public_path__ + "static/media/shop-front-spraying-001-thumbnail.4c388b1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/thumbnails/shop-front-spraying-001-thumbnail.jpg
// module id = 105
// module chunks = 0